/*
* Copyright (c) Microsoft Corporation. All rights reserved.
* Licensed under the MIT License.
*/
/* eslint-disable default-case */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

console.log('process.env (not used)', process.env)
console.log('window._env_ (used)', window._env_)

    
//mandatory fields
// const client_url = process.env.REACT_APP_CLIENT_URL 
// const clientId = process.env.REACT_APP_CLIENT_ID;
// const authority = process.env.REACT_APP_AUTHORITY;
// const scope = process.env.REACT_APP_SCOPE;
// const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
const client_url = window._env_.REACT_APP_CLIENT_URL 
const clientId = window._env_.REACT_APP_CLIENT_ID;
const authority = window._env_.REACT_APP_AUTHORITY;
const scope = window._env_.REACT_APP_SCOPE;
const api_endpoint = window._env_.REACT_APP_API_ENDPOINT;

console.log('client_url: ' + client_url)
console.log('clientId: ' + clientId)
console.log('authority: ' + authority)
console.log('scope: ' + scope)
console.log('api_endpoint: ' + api_endpoint)
console.log('PUBLIC_URL (from window._env_): ' + window._env_.PUBLIC_URL)



export const msalConfig = {
    auth: {

        clientId: clientId, // This is the ONLY mandatory field that you need to supply.
        // clientId: "f6289fa0-1afd-4cd5-9625-df5b7d63969f", // This is the ONLY mandatory field that you need to supply.
        authority: authority, // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: client_url, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: client_url, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        // loggerOptions: {
        //     loggerCallback: (level, message, containsPii) => {
        //         if (containsPii) {
        //             return;
        //         }
        //         switch (level) {
        //             case LogLevel.Error:
        //                 console.error(message);
        //                 return;
        //             case LogLevel.Info:
        //                 console.info(message);
        //                 return;
        //             case LogLevel.Verbose:
        //                 console.debug(message);
        //                 return;
        //             case LogLevel.Warning:
        //                 console.warn(message);
        //                 return;
        //         }
        //     }
        // }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [scope]
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["openid", "profile"],
    loginHint: "example@bkvcorp.com"
};